import { ROUTES } from '@/constants/routes.constants';
import RetroAdventures from './assets/RetroAdventures.png';
import RetroBridge from './assets/RetroBridge.png';
import RetroBridgeAdvanced from './assets/RetroBridgeAdvanced.svg';
import TestnetBridgeAndFaucet from './assets/TestnetBridgeAndFaucet.png';
import DAppExplorer from './assets/DAppExplorer.png';

export enum EcosystemTabs {
  RetroBridge = 'RetroBridge',
  RetroBridgeAdvanced = 'RetroBridgeAdvanced',
  TestnetBridgeAndFaucet = 'TestnetBridgeAndFaucet',
  RetroAdventures = 'RetroAdventures',
  DAppExplorer = 'DAppExplorer',
}

interface EcosystemTab {
  key: EcosystemTabs;
  heading: string;
  description: string;

  tabTitle: string;

  actionText: string;
  actionLink: string;

  image: string;
}

export const ecosystemTabsContent: EcosystemTab[] = [
  {
    key: EcosystemTabs.RetroBridge,
    heading: 'RetroBridge',
    description:
      'Instantly bridge and swap assets with lowest market fees between EVM and non-EVM networks',

    tabTitle: 'RetroBridge',

    actionText: 'Launch app',
    actionLink: ROUTES.SEND_PAGE,

    image: RetroBridge,
  },
  {
    key: EcosystemTabs.RetroBridgeAdvanced,
    heading: 'RetroBridge Advanced',
    description:
      'Perform seamless bridging from a single source network address to multiple destination networks and addresses without using smart contracts.',

    tabTitle: 'RetroBridge Advanced',

    actionText: 'Launch Advanced Mode',
    actionLink: `${ROUTES.SEND_PAGE}?mode=advanced`,

    image: RetroBridgeAdvanced,
  },
  {
    key: EcosystemTabs.TestnetBridgeAndFaucet,
    heading: 'Testnet Bridge & Faucet',
    description:
      'Support emerging networks by bridging and performing activities on their testnets, aiding in the development and scaling of new blockchain projects.',

    tabTitle: 'Testnet Bridge & Faucet',

    actionText: 'Launch Testnet & Faucet',
    actionLink: ROUTES.TESTNET_SEND_PAGE,

    image: TestnetBridgeAndFaucet,
  },
  {
    key: EcosystemTabs.RetroAdventures,
    heading: 'Retro Adventures',
    description:
      'Engage in cross-chain quests that involve various blockchains and their dApps, offering an interactive way to explore, learn different ecosystems.',

    tabTitle: 'Retro Adventures',

    actionText: 'Launch Retro Adventures',
    actionLink: ROUTES.QUESTS_PAGE_ADVENTURES,

    image: RetroAdventures,
  },
  {
    key: EcosystemTabs.DAppExplorer,
    heading: 'Dapp Explorer',
    description:
      "Explore which Dapps are available for interaction on any network you're bridging to",

    tabTitle: 'Dapp Explorer',

    actionText: 'Launch Dapp Explorer',
    actionLink: ROUTES.DAPP_EXPLORER_PAGE,

    image: DAppExplorer,
  },
];
